<template>
  <Modal class-name="vertical-center-modal" v-model="isModal" title="设置总监" width="300">
    <div class="form-wrapper">
      <div class="tip-wrap">
        <div>{{content}}</div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">保存</span>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
  import { Modal, Spin } from 'view-design'
  import member from  '@/javaApi/member.js'
  const memberModel = new member()
  export default {
    name: "SetDirector",
    components: {
      Modal,
      Spin
    },
    data: function() {
      return {
        isModal: false,
        loading: false,
        content: '确定将该用户设置为总监？',
        type:0,
        sourceData:{},
      }
    },
    methods: {
      init: function(isModal, row) {
        this.loading = true
        // let type = 2;
        // if(type == 2){
        //   this.content = '该用户已有推荐人，是否解除推荐人关系并设置为总监？'
        // }else if(type == 3){
        //   this.content = '该用户已有推荐人和被邀请会员，不能设置为总监';
        // }else{
        //   this.content = '确定将该用户设置为总监？';
        // }
        if(row.parentUuid == 0){
          this.content = '确定将该用户设置为总监?'
          this.type = 0
        } else if(row.isHasNextLevel){
            this.type = 3
            this.content = '该用户已有推荐人和被邀请会员，不能设置为总监';
        }else{
          this.content = '该用户已有推荐人，是否解除推荐人关系并设置为总监？'
          this.type = 2
        }
        this.sourceData = row
        this.isModal = isModal
        this.loading = false
      },
      handelSubmit:function(){
        if(this.type == 0 || this.type == 2){
            let param = {
                uuid :this.sourceData.uuid
            }
            let that = this
            this.loading = true
            memberModel.updateWithoutMajor(param).then(response=>{
              let res = response.data
              that.loading = false
              if(res.code == 200){
                that.$message.success('设置成功')
                that.isModal = false
                that.$emit('refresh')
              } else {
                let message = res.message?res.message:'系统异常,请稍后再试'
                that.$message.error(message)
              }
            }).catch(error=>{
                that.loading = false
                console.log(error)
                if(error != 'token invalid'){
                    that.$message.error('系统异常请稍后再试')
                }
            })
        }else{
            this.isModal = false;
        }
      }
    }
  }
</script>

<style scoped>
  >>>.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  >>>.vertical-center-modal .ivu-modal {
    top: 0;
    width: 300px;
    margin: 30px !important;
  }

  >>>.vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 12px 18px 20px 18px;
    text-align: right;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .footer-wrapper .btn {
    display: block;
    width: 100%;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    border-radius: 20px;
    text-align: center;
  }

  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }

  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    color: #222222;
    background: #F2F2F2;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/official/member/modal/SetDirector.vue